import React from 'react';
import {withRouter} from 'react-router';

import CONSTANTS from 'client/constants';
import {useFluxStore} from 'client/framework';
import sessionStore from 'client/Session/SessionStore';
import ErrorPage from 'client/static/Error/ErrorPage.react';

import {DashboardHeader} from './DashboardHeader';
import {TeacherDashboardLayout} from './TeacherDashboardLayout';

interface Props {
  children: React.ReactNode;
  router: {location: {pathname?: string}};
}

/**
 * Chrome for the cross-class classwork routes (Assignments, Folders, Subjects, Skill Paths): the
 * dashboard shell with the scope-aware header. These are teacher pages, so anyone without teacher
 * access (teachers, school admins, supers) gets the Access denied page at the same URL.
 */
const ClassworkChrome = ({children, router}: Props) => {
  const hasTeacherAccess = useFluxStore(sessionStore, (s) => s.hasTeacherAccess());

  if (!hasTeacherAccess) {
    return <ErrorPage errorCode={CONSTANTS.ERROR_TYPES.UNAUTHORIZED} />;
  }

  const pathname = router.location.pathname ?? '';
  return (
    <TeacherDashboardLayout header={<DashboardHeader pathname={pathname} />} pathname={pathname}>
      {children}
    </TeacherDashboardLayout>
  );
};

export default withRouter(ClassworkChrome);
